module.exports = __webpack_public_path__ + "media/src/img/help-tree-76cb52ed900460bf4cdee92fd4adf63d.svg";